import { DevicesActionTypes } from './actionTypes';
import type { DevicesAction } from './actions';

import { type WebData, isWebDataSuccess, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';
import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';

interface DevicesState {
  devicesWebData: WebData<DeviceFragment[]>;
}

export const devicesInitialState: DevicesState = {
  devicesWebData: webDataNotAsked(),
};

export const devicesReducer = (state: DevicesState = devicesInitialState, action: DevicesAction): DevicesState => {
  switch (action.type) {
    case DevicesActionTypes.LOAD_DEVICES_REQUEST:
      return {
        ...state,
        devicesWebData: webDataFetching(),
      };

    case DevicesActionTypes.LOAD_DEVICES_SUCCEEDED:
      return {
        ...state,
        devicesWebData: webDataSuccess(action.payload),
      };

    case DevicesActionTypes.LOAD_DEVICES_FAILED:
      return {
        ...state,
        devicesWebData: webDataError(),
      };

    case DevicesActionTypes.LOAD_DEVICE_STATUS_SUCCESS:
      const deviceStatusEvents = action.payload;
      if (isWebDataSuccess(state.devicesWebData)) {
        let devices: DeviceFragment[] = [...state.devicesWebData.data];

        deviceStatusEvents.forEach((deviceStatusEvent) => {
          const { deviceId, ...lastLocation } = deviceStatusEvent;
          const deviceIndex = devices.findIndex((device) => device.id === deviceId);

          if (deviceIndex >= 0) {
            const foundDevice = devices[deviceIndex];
            if (!foundDevice.lastLocation || (foundDevice.lastLocation.timeInMillis && lastLocation.date > foundDevice.lastLocation.timeInMillis)) {
              const updateDevice: DeviceFragment = {
                ...foundDevice,
                lastLocation,
              };

              devices = [...devices.slice(0, deviceIndex), updateDevice, ...devices.slice(deviceIndex + 1)];
            }
          }
        });

        return {
          ...state,
          devicesWebData: webDataSuccess(devices),
        };
      }
      return state;

    default:
      return state;
  }
};
